import {
  AutocompleteInput,
  DateInput,
  FileField,
  FileInput,
  FormDataConsumer,
  maxValue,
  minValue,
  NumberInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
} from 'react-admin'

import {
  MAX_NUM_TEAMS,
  maxPricePerGallon,
  maxTotalGallons,
  minPricePerGallon,
  minTotalGallons,
} from '../../helpers/constants'
import { US_STATES } from '../../helpers/states'
import { validateThreeDecimals } from '../../helpers/validators'
import { FullNameField } from '../Fields'

const fullNameInput = (choice: any) => (choice ? `${choice.first_name} ${choice.last_name}` : '')
const validatePricePerGallon = [
  required(),
  maxValue(maxPricePerGallon),
  minValue(minPricePerGallon),
  validateThreeDecimals,
]
const validateTotalGallons = [
  required(),
  maxValue(maxTotalGallons),
  minValue(minTotalGallons),
  validateThreeDecimals,
]

export const FuelForm = (props: any) => (
  <SimpleForm {...props} toolbar={props.fueltoolbar}>
    <ReferenceInput
      label="Team"
      source="team"
      reference="teams"
      filterToQuery={(searchText) => ({ search: searchText })}
      filter={{ is_real: true }}
      sort={{ field: 'name', order: 'ASC' }}
      allowEmpty={true}
      validate={required()}
      perPage={MAX_NUM_TEAMS}
      alwaysOn
    >
      <AutocompleteInput optionText="name" name="team" />
    </ReferenceInput>
    <FormDataConsumer>
      {({ formData, ...rest }: any) => {
        const defaultValue = Object.keys(rest.record).length !== 0 ? rest.record.reported_by.id : ''
        return (
          formData.team && (
            <ReferenceInput
              defaultValue={defaultValue}
              label="Reported by"
              source="user.id"
              reference="users"
              sort={{ field: 'first_name', order: 'ASC' }}
              allowEmpty={false}
              validate={required()}
              filter={{ team: formData.team }}
              alwaysOn
            >
              <SelectInput optionText={<FullNameField />} inputText={fullNameInput} />
            </ReferenceInput>
          )
        )
      }}
    </FormDataConsumer>
    <FormDataConsumer>
      {({ formData, ...rest }: any) => {
        const defaultValue = Object.keys(rest.record).length !== 0 ? rest.record.truck.id : ''
        return (
          formData.team && (
            <ReferenceInput
              label="Truck plate"
              source="truck.id"
              defaultValue={defaultValue}
              reference="trucks"
              sort={{ field: 'license_plate_number', order: 'ASC' }}
              allowEmpty={false}
              validate={required()}
              filter={{ team: formData.team }}
              alwaysOn
            >
              <SelectInput optionText="license_plate_number" />
            </ReferenceInput>
          )
        )
      }}
    </FormDataConsumer>
    <DateInput source="date_purchased" validate={required()} />
    <SelectInput
      source="jurisdiction"
      label="Purchase State"
      choices={US_STATES}
      optionText="abbreviation"
      optionValue="abbreviation"
      validate={required()}
    />
    <NumberInput source="price_per_gallon" validate={validatePricePerGallon} />
    <NumberInput source="total_gallons" validate={validateTotalGallons} />
    <FileInput
      source="fuel_attachment"
      label="Receipt Image"
      accept="application/pdf, image/jpeg, image/png, image/gif"
      placeholder={<p>Drop your file here</p>}
      validate={required()}
    >
      <FileField title="Fuel attachment" />
    </FileInput>
  </SimpleForm>
)
